/**
   *  通用公共的接口
   */
let commonRequest = {
  // 通用下拉框接口key、value
  async getSelectData (obj, type) {
    let result = await obj.$http.post(obj.$API.common.getSelect, { selectType: type })
    return result
  },
  async getDic (obj, code) {
    let result = await obj.$http.post(obj.$API.common.dicSelect, { dictCode: code })
    return result
  },

}
export default commonRequest
